import { cn } from "@city-sage/aurum-avis-labs-components"

export function ItineraryCardSkeleton() {
  return (
    <div className="group relative overflow-hidden rounded-xl">
      <div className="relative h-80 aspect-[3/5] w-full overflow-hidden bg-gray-200 dark:bg-gray-800">
        {/* Image skeleton */}
        <div className="absolute inset-0 animate-pulse bg-gradient-to-b from-transparent to-gray-300/50 dark:to-gray-700/50" />

        {/* Content skeleton */}
        <div className="absolute bottom-0 left-0 right-0 p-4">
          {/* Title skeleton */}
          <div className="h-6 w-3/4 animate-pulse rounded-md bg-gray-300 dark:bg-gray-700" />
          
          {/* Description skeleton */}
          <div className="mt-2 space-y-2">
            <div className="h-4 w-full animate-pulse rounded-md bg-gray-300 dark:bg-gray-700" />
            <div className="h-4 w-2/3 animate-pulse rounded-md bg-gray-300 dark:bg-gray-700" />
          </div>

          {/* Metadata skeleton */}
          <div className="mt-3 flex items-center gap-3">
            <div className="h-4 w-20 animate-pulse rounded-md bg-gray-300 dark:bg-gray-700" />
            <div className="h-4 w-16 animate-pulse rounded-md bg-gray-300 dark:bg-gray-700" />
          </div>
        </div>
      </div>

      {/* Like button skeleton */}
      <div className="absolute right-3 top-3 z-10">
        <div className="h-8 w-8 animate-pulse rounded-full bg-gray-300 dark:bg-gray-700" />
      </div>

      {/* Author skeleton */}
      <div className="absolute left-3 top-3 z-10">
        <div className="h-6 w-24 animate-pulse rounded-full bg-gray-300 dark:bg-gray-700" />
      </div>
    </div>
  )
} 